<template>
  <b-sidebar
      :id="drawerId"
      title="Sidebar"
      v-model="open"
      bg-variant="white"
      width="560px"
      sidebar-class="border"
      shadow
      right
      no-header
  >
    <template #default="{  }">
      <div class="d-flex align-items-center justify-content-between ps-3 border-bottom">
        <div class="drawer-title">Balancing</div>
        <b-button variant="white" @click="closeDrawer">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                fill="#454646"/>
          </svg>
        </b-button>
      </div>
      <div class="p-3 h-100 d-grid">
        <Loader :loading="loading" no-axios>
          <div class="container" v-if="model && model.id">
            <div class="row">
              <div class="col-md-6 p-0">
                <div class="col-md-12">
                  <div class="label">No Laporan Penjualan</div>
                  <div class="value">
                    <router-link :to="`/sale_notes/${model.sale_order.id}`">
                      {{ model.sale_order.id }}
                    </router-link>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="label">Tanggal Nota Bongkar</div>
                  <div class="value">
                    {{ $moment.utc(model.sale_order.ordered_at).local().format('DD MMM YYYY') }}
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="label">Pabrik</div>
                  <div class="value">
                    {{ model.manufacture.name }}
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="label">Nominal Balancing</div>
                  <div class="value">
                    {{ $numeral(Math.abs(model.debt)).format('$ 0,0.[00]') }}
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="label">Penyesuaian</div>
                  <div class="value">
                    <b-form-group
                    >
                      <b-input-group>
                        <numeral-input
                            v-model="model.adjustment"
                            id="adjustment"
                            name="adjustment"
                            format="$ 0,0.[00]"
                            :disabled="adjustmentDisabledRules"
                            lazy-formatter
                        />
                      </b-input-group>
                    </b-form-group>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="label">Setelah Penyesuaian</div>
                  <div class="value">
                    <numeral-input
                        :value="model.debt + (model.adjustment || 0)"
                        id="after_adjustment"
                        name="after_adjustment"
                        format="$ 0,0.[00]"
                        disabled
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="col-md-12">
                  <div class="label">No Folder</div>
                  <div class="value">
                    <router-link :to="`/tickets/${model.sale_order.ticket_id}`">
                      {{ model.sale_order.ticket_id }}
                    </router-link>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="label">No Nota Bongkar</div>
                  <div class="value">
                    <router-link :to="`/unloads/${model.sale_order.id}`">
                      {{ model.sale_order.id }}
                    </router-link>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="label">Mitra</div>
                  <div class="value">
                    {{ model.customer.name }}
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="label">Status Pembayaran</div>
                  <div class="value">
                    <router-link :to="status.url || '#'">
                      <span v-html="status.label" :class="status.style"></span>
                    </router-link>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="label">Catatan</div>
                  <div class="value">
                    <b-form-textarea
                        id="note"
                        type="text"
                        name="note"
                        v-model="model.description"
                        :placeholder="lodash.startCase($t('sale_notes.invoices.note_content'))"
                        style="height: 124px"
                        :disabled="!allowUpdate"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div v-if="updateStatus === 'updating'">
                    <i class="text-info mdi mdi-loading mdi-spin"></i>
                    {{lodash.startCase($t('models.updating'))}}
                  </div>
                  <div v-else class="d-flex gap-2">
                    <div><i class="bx bxs-check-circle text-success"></i></div>
                    <div>
                      <div>{{ lodash.startCase($t('models.updated_at')) }}: <span>{{ $moment.utc(model.updated_at).local().format('DD MMMM YYYY hh:mm:ss') }}</span></div>
                      <div>Oleh: <span v-if="model.updater">{{model.updater.name}}</span><span v-else>-</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Loader>
      </div>
    </template>
  </b-sidebar>
</template>
<script>
import BaseDrawer from "@/components/drawers/base-drawer.vue";
import NumeralInput from "@/components/inputs/numeral.vue";
import Loader from "@/components/widgets/loader.vue";
import _ from "lodash";

export default {
  name: "balancing-show-drawer",
  extends: BaseDrawer,
  components: {
    NumeralInput,
    Loader,
  },
  data() {
    return {
      model: null,
      loading: true,
      allowUpdate: false,
      updateStatus: 'updated',
      allowUpdateTimeout: null,
    }
  },
  watch: {
    'model.adjustment': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if(typeof newVal === 'number'){
          this.update({
            adjustment: newVal
          });
        }
      }
    },
    'model.description': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.update({
          description: newVal
        });
      }
    }
  },
  computed: {
    adjustmentDisabledRules() {
      return !this.allowUpdate || this.model.balancing_payments_count > 0;
    },
    updateStatusMessage() {
      if (this.updateStatus === 'updated') return `${this.lodash.upperFirst(this.$t('updated_at'))} ${this.$moment.utc(this.salesInvoice.updated_at).local().format('DD MMMM YYYY hh:mm')}`
      if (this.updateStatus === 'updating') return  this.lodash.upperFirst(this.$t('updating'))
      return this.lodash.upperFirst(this.$t('failed_to_update'))
    },
    status_() {
      const remaining_debt = this.model.remaining_debt || 0
      if (remaining_debt === 0) return this.lodash.upperFirst(this.$t('paid off'))
      return remaining_debt > 0 ?
          this.lodash.upperFirst(this.$t('underpaid {nominal}', {nominal: `<br>${this.$numeral(remaining_debt).format('$ 0,0.[00]')}`})) :
          this.lodash.upperFirst(this.$t('balancing_payments.overpaid {nominal}'), {nominal: `<br>${this.$numeral(Math.abs(remaining_debt)).format('$ 0,0.[00]')}`})
    },
    statusStyle(){
      const remaining_debt = this.model.remaining_debt || 0
      if (remaining_debt === 0) return 'text-success'
      return remaining_debt > 0 ? 'text-warning' : 'text-success'
    },
    status(){
      const remaining_debt = this.model.remaining_debt || 0
      if(this.model.balancing_payments_count === 0) return {
        label: this.lodash.upperFirst(this.$t('unpaid')),
        style: 'text-danger',
        url: `/balancing_payments?balancing_payment_create__balancing_transaction_id=${this.model.id}`
      };
      if (remaining_debt === 0) return {
        label: this.lodash.upperFirst(this.$t('paid off')),
        style: 'text-success',
        url: `/balancing_payments?balancing_payment_show__id=${this.model.balancing_payments?.[0]?.id}`
      }
      return remaining_debt > 0 ? {
        label: this.lodash.upperFirst(this.$t('underpaid {nominal}', {nominal: `<br>${this.$numeral(remaining_debt).format('$ 0,0.[00]')}`})),
        style: 'text-warning',
        url: `/balancing_payments?balancing_payment_create__balancing_transaction_id=${this.model.id}`
      } : {
        label: this.lodash.upperFirst(this.$t('balancing_payments.overpaid {nominal}', {nominal: `<br>${this.$numeral(Math.abs(remaining_debt)).format('$ 0,0.[00]')}`})),
        style: 'text-success',
        url: `/balancing_payments?balancing_payment_show__id=${this.model.balancing_payments?.[0]?.id}`
      }
    }
  },
  methods: {
    update: _.debounce(function (value) {
      if (this.model?.id) {
        if(this.allowUpdate){
          this.handleUpdate(value);
        }
      }
    }, 1000),
    handleUpdate(value) {
      this.$toast.clear();
      this.updateStatus = 'updating';
      return this.$axios.put(`/balancing_transactions/${this.model.id}`, value)
          .then(() => {
            return this.fetchModel(this.model.id, false).then(() => {
              this.$emit('updated', this.model)
              this.updateStatus = 'updated';
              this.$toast("Perubahan berhasil disimpan", {
                type: "success",
                timeout: 10000,
                position: "bottom-left",
              });
            });
          }).catch(() => {
            this.updateStatus = 'failed';
            this.$toast("Perubahan gagal disimpan",{
              type: "error",
              icon: {
                iconClass: "mdi mdi-close-circle toast-icon text-danger",
              },
              timeout: 10000,
              position: "bottom-left",
            });
          }).finally(() => {
            this.loading = false;
          })
    },
    fetchModel(modelId, loader=true) {
      this.loading = loader;
      return this.$axios.get(`/balancing_transactions/${modelId}`, {
        params: {
          with: [
            'sale_order',
            'customer',
            'profit_share',
            'manufacture',
            'updater',
            'balancing_payments'
          ].join(','),
          with_count: [
            'balancing_payments',
          ].join(','),
        }
      }).then((response) => {
        const {data: {data}} = response;
        this.model = data;
        this.allowUpdateTimeout = setTimeout(() => {
          this.allowUpdate = true;
        }, 1200);
        return response;
      }).catch((error) => this.failedAlert(error)).finally(() => {
        this.loading = false
      })
    },
    show(modelId) {
      const timeout = this.open ? 200 : 0
      this.closeDrawer();
      window.clearTimeout(this.allowUpdateTimeout);
      setTimeout(() => {
        this.openDrawer();
        this.model = null;
        this.updateStatus = 'updated';
        this.allowUpdate = false;
        this.fetchModel(modelId);
      }, timeout)
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer {
  width: 560px;
}

.drawer-title {
  color: #0084F3;
  font-size: 16px;
  font-weight: 800;
  line-height: 20px; /* 125% */
  letter-spacing: 0.8px;
}
</style>

<style lang="scss" scoped>
.label {
  color: var(--neutral-800, var(--colors-slate-800, #1E293B));
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.26px;
}

.value {
  color: var(--neutral-600, var(--colors-slate-600, #475569));
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-block: 4px;
  margin-bottom: 12px;
}
</style>